import api from "./api";

class ContactService {
    search(term, params = {}) {
        return api.get("/api/contacts/", { params: { search: term, ...params } });
    }

    list(params = {}) {
        return api.get("/api/contacts/", { params });
    }

    get(id) {
        return api.get(`/api/contacts/${id}/`);
    }

    getByCompany(companyId) {
        return api.get("/api/contacts/", { params: { company: companyId } });
    }
}

export default new ContactService();
